/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { aiMetadataStates } from '@/configs/server-enums'
import { AI_METADATA } from '@/configs/strings/ai-metadata.strings'
import { AI_METADATA_BUILT_TITLE } from '@/configs/strings/licensed-assets'

export const builtSuccessfully = [
  aiMetadataStates.shared,
  aiMetadataStates.registered,
  aiMetadataStates.pendingShare
]
export const builtSuccessfullyString = builtSuccessfully.join()

const titleByState = {
  registered: `${AI_METADATA} registered`,
  failed: `${AI_METADATA} failed`,
  shared: `${AI_METADATA} shared`,
  pendingShare: `${AI_METADATA} pending to share`,
  builtSuccessfully: `All ${AI_METADATA_BUILT_TITLE} successfully`
}

export const getTitle = (state) => {
  if (state === builtSuccessfullyString) {
    return titleByState.builtSuccessfully
  }

  const stateKeys = Object.keys(aiMetadataStates)
  const stateValues = Object.values(aiMetadataStates)
  const currentStateIndex = stateValues.findIndex(
    (aimState) => state === aimState
  )
  const stateKey = stateKeys[currentStateIndex]

  return titleByState[stateKey] || ''
}

export const filterOptions = [
  {
    label: getTitle(aiMetadataStates.registered),
    status: aiMetadataStates.registered
  },
  {
    label: getTitle(aiMetadataStates.failed),
    status: aiMetadataStates.failed
  },
  {
    label: getTitle(aiMetadataStates.pendingShare),
    status: aiMetadataStates.pendingShare
  },
  {
    label: getTitle(aiMetadataStates.shared),
    status: aiMetadataStates.shared
  },
  {
    label: getTitle(builtSuccessfullyString),
    status: builtSuccessfullyString
  }
]
